import { SignupDto, UpdatePhoneDto } from "@onair/repositories";
import { signUp, updatePhone } from "@onair/services/auth";
import { useMutation } from "@tanstack/react-query";

export const useMutationSignUp = () => {
	return useMutation({
		mutationFn: (data: SignupDto) => signUp(data),
	});
};

export const useMutationUpdatePhone = () => {
	return useMutation({
		mutationFn: (data: UpdatePhoneDto) => updatePhone(data),
	});
};
